import Rete from 'rete';

import { distSocket } from './index';

import TextControl from './TextControl';


export default class InputComponent extends Rete.Component {
	constructor() {
		super("Input");
		this.path = ["Module"];
		this.contextMenuName = "Input";
		this.module = {
			nodeType: 'input',
			socket: distSocket
		}
	}

	builder(node) {
		let out1 = new Rete.Output('output', "Output", distSocket);
		let ctrl = new TextControl(this.editor, 'name');

		ctrl.component.methods.onChange = () => {
			node.update();
		}

		return node.addControl(ctrl).addOutput(out1);
	}
	
	/*async worker(node, inputs, outputs) {
				if (!outputs['num'])
						outputs['num'] = node.data.number; // here you can modify the output returned to the module
		}*/
}
